(function () {
  var display = "(323) 709-0035";
  var tel = "+13237090035";

  function patch() {
    document
      .querySelectorAll('a[href*="2138874264"], a[href*="887-4264"]')
      .forEach(function (a) {
        a.setAttribute("href", "tel:" + tel);
        a.querySelectorAll("span").forEach(function (s) {
          if (/887/.test(s.textContent)) s.textContent = display;
        });
      });
    document
      .querySelectorAll(".rte-setting, .footer__content, .site-footer")
      .forEach(function (el) {
        if (!el.innerHTML || el.innerHTML.indexOf("887-4264") === -1) return;
        el.innerHTML = el.innerHTML
          .replace(/\(213\)\s*887-4264/g, display)
          .replace(/tel:2138874264/g, "tel:" + tel);
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", patch);
  } else {
    patch();
  }
})();
